import React from 'react';
import {connect} from 'dva';
import {utils_tool, framework_tool,component_tool} from '@/tool';
import {reduxTemplateConfig, templateConfig} from './config';

let {Session} = utils_tool
let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let {
  WizCard,
  WizRow,
  WizCol,
  WizBrowserExport
} = component_tool

class ClassStudentSweepCodeList extends WizContainer {
  componentName = 'ClassStudentSweepCodeList';

  constructor(props) {
    super(props);
    this.state = {}
  }

  _componentWillMount() {
    const {history} = this.props;

    if (history.location.record) {
      Session.set('classDetail', history.location.record);
      this.initialValue = history.location.record;
    } else if(Session.get('classDetail')) {
      this.initialValue = Session.get('classDetail') ? Session.get('classDetail') : {}
    }

  }

  _render() {
    let initialValue = this.initialValue;
    let {id, name,startDate, endDate, lectureName} = initialValue;

    let titles = [
      {name: '班级名称', value: name, span: 8},
      {name: '班级时间', value: startDate || endDate ? (startDate + ' ~ ' + endDate) : '', span: 10},
      {name: '讲师', value: lectureName, span: 6}
    ];

    let _templateConfig = templateConfig({})
    let _reduxTemplateConfig = reduxTemplateConfig({
      classInfoId: id,
      templateConfig: _templateConfig,
      apiDataFormat: {
        exportPerson: this._handleClassStudentFile,
      },
    });

    return (
      <>
        <WizCard title="班级概况">
          <WizRow style={{padding:0,marginLeft:"100px"}}>
            {
              titles.map((item, index) => {
                return (
                  <WizCol span={item.span}>
                    {item.name}: {item.value}
                  </WizCol>
                )
              })
            }
          </WizRow>
        </WizCard>
        <WizCard title="扫码入店记录">
          <WizReduxTemplate {..._reduxTemplateConfig} />
        </WizCard>
      </>
    );
  }

  _handleClassStudentFile(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      let columnDefs = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'center',
            padding: '5px 0',
            color: '#595959',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
          },
        },
        {
          headerName: '姓名',
          field: 'fullName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '账号',
          field: 'userName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '组织名称',
          field: 'orgName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '组织编码',
          field: 'orgCode',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '岗位',
          field: 'positionName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '任职状态',
          field: 'jobStateName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '扫码入班时间',
          field: 'scanCreateTime',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '扫码地址',
          field: 'location',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '创建人',
          field: 'lecturerName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '创建时间',
          field: 'qrCreateTime',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: '创建地址',
          field: 'lecturerLocation',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
      ]

      let data = o['data'];
      WizBrowserExport({
        title: '扫码入店记录',
        sheetName: '扫码入店记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '扫码入店记录.xlsx',
      })

      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }
}


const mapStateToProps = (state, ownProps) => {
  const { classStudentManagement } = state;

  const load = modelUtils.getLoadingState(state, ['classStudentManagement']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ClassStudentSweepCodeList);
